import type React from 'react'
import { cn } from '../lib/utils'
import { Badge } from './ui/badge'

interface NotificationBadgeProps {
  count: number
  size?: 'sm' | 'md' | 'lg'
  color?: 'red' | 'blue' | 'green' | 'yellow' | 'gray'
  showDot?: boolean // New prop to show dot instead of count
}

const NotificationBadge: React.FC<NotificationBadgeProps> = ({
  count,
  size = 'md',
  color = 'red',
  showDot = false,
}) => {
  if (count <= 0) return null

  const sizeClasses = {
    sm: showDot
      ? 'w-2 h-2 min-w-0'
      : 'text-[9px] sm:text-[10px] min-w-[14px] sm:min-w-[16px] h-3.5 sm:h-4 px-1 sm:px-1.5 py-0',
    md: showDot
      ? 'w-2.5 h-2.5 min-w-0'
      : 'text-[9px] sm:text-[10px] min-w-[16px] sm:min-w-[18px] h-4 sm:h-[18px] px-1 sm:px-1.5 py-0',
    lg: showDot
      ? 'w-3 h-3 min-w-0'
      : 'text-[10px] sm:text-xs min-w-[18px] sm:min-w-[20px] h-4 sm:h-5 px-1.5 sm:px-2 py-0',
  }

  const colorClasses = {
    red: 'bg-red-500 text-white hover:bg-red-600',
    blue: 'bg-blue-500 text-white hover:bg-blue-600',
    green: 'bg-green-500 text-white hover:bg-green-600',
    yellow: 'bg-yellow-500 text-white hover:bg-yellow-600',
    gray: 'bg-gray-500 text-white hover:bg-gray-600',
  }

  return (
    <Badge
      className={cn(
        'border-transparent flex items-center justify-center ml-1 sm:ml-2 font-semibold',
        showDot ? 'rounded-full p-0' : '',
        sizeClasses[size],
        colorClasses[color],
      )}
    >
      {!showDot && count}
    </Badge>
  )
}

export default NotificationBadge
